import getStarted1 from '../../../assets/images/get_started_1.png';
import getStarted2 from '../../../assets/images/get_started_2.png';
import getStarted3 from '../../../assets/images/get_started_3.png';
import { COURT_NAME } from '../../../lib/constants/globalConstant';

//FOR DEMO CHANGED SELECT YOUR TOKENS 

// Pick your token => Select you tokens
// your team's digital field => the digital replica of Alamadome

const getStartedData = [
    {
        id: 1,
        heading: "Create an Account",
        description: "Sign up quickly and easily to start your token journey.",
        image: getStarted1,
    },
    {
        id: 2,
        heading: "Select your tokens",
        description: `Browse available sections of the digital replica of ${COURT_NAME} and choose your token.`,
        image: getStarted2,
    },
    {
        id: 3,
        heading: "Join the Game",
        description: "Watch as your token lights up with every play, and start earning rewards right away.",
        image: getStarted3,
    },
]

export default getStartedData